import mapCartItem from '../shared/map-cart-item'

export default function(config, cartItem, analytics) {
    analytics.track('add_to_cart', {
        ecommerce: {
            currency: 'USD',
            value: cartItem.total,
            items: [mapCartItem(cartItem)],
        },
    })
}
